import React, { lazy } from 'react';

const UserHome = lazy(
  () => import('../UserRoutes/UserHomepage/UserHomePage.page.jsx')
);
const UserSettings = lazy(
  () => import('../UserRoutes/UserSettings/UserSettingsHome.page.jsx')
);
const AllCoursesPage = lazy(
  () => import('../UserRoutes/UserHomepage/UserAllCourses.page.jsx')
);
const UserPurchaseHistory = lazy(
  () => import('../UserRoutes/PurchaseHistory/UserPurchaseHistory.page.jsx')
);
const CertificatesPage = lazy(
  () => import('../UserRoutes/UserCertificates/Certificates.page.jsx')
);
const UserDetailsBasePage = lazy(
  () => import('../UserDetails/UserDetails.page.jsx')
);
const FormHomepageUser = lazy(
  () => import('../Forms/UserForms/AllFormsHomepage/FormHomepageUser.page.jsx')
);
const DisplayFormUser = lazy(
  () =>
    import(
      '../Forms/UserForms/SingleFormHomepage/DisplaySelectedFormUser.page.jsx'
    )
);
const FormInstancesHomepageUser = lazy(
  () =>
    import(
      '../Forms/UserForms/FormInstancesHomepage/FormInstancesHomepageUser.page.jsx'
    )
);
const ManualHomepage = lazy(
  () => import('../CompanyRoutes/Manual/ManualHomepage.page.jsx')
);

export const userRoutes = [
  { path: '', element: <UserHome /> },
  { path: 'settings/:id', element: <UserSettings /> },
  { path: 'all-courses', element: <AllCoursesPage /> },
  { path: 'purchase-history', element: <UserPurchaseHistory /> },
  { path: 'certificates', element: <CertificatesPage /> },
  { path: 'profile/:id', element: <UserDetailsBasePage /> },
  { path: 'forms/:companyId', element: <FormHomepageUser /> },
  { path: 'forms/instances/:formId', element: <FormInstancesHomepageUser /> },
  { path: 'forms/edit/:formId/:instanceId', element: <DisplayFormUser /> },
  { path: 'manual/:id/', element: <ManualHomepage /> },
];
